import React, { FunctionComponent, useState } from 'react';

import {
  Snackbar
} from '@mui/material';
import MuiAlert from '@mui/material/Alert';

type AlertSomethingWentWrongProps = {
  open: boolean;
  setOpen: (f:boolean) => void;
};

export const AlertSomethingWentWrong: FunctionComponent<AlertSomethingWentWrongProps> = ({open, setOpen}) => {
  const [snackOpen, setSnackOpen] = useState<boolean>(open);

  return (<>
    <Snackbar
      open={snackOpen}
      onClose={() => {setSnackOpen(false); if (!!setOpen) setOpen(false);}}
      autoHideDuration={6000}
    >
      <MuiAlert elevation={6} variant="filled" severity="error">
        Something went wrong!
      </MuiAlert>
    </Snackbar>
  </>);
}